import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/composables/permissions/permissions';

export default [
  {
    path: 'network',
    redirect: { name: 'client-network' },
    meta: {
      permissions: [Permission.ClientsNetworkView],
    },
  },
  {
    path: 'network/visualisation',
    name: 'client-network',
    component: () => import('./ClientNetwork.vue'),
    meta: {
      permissions: [Permission.ClientsNetworkView],
    },
  },
  {
    path: 'network/table',
    name: 'client-table',
    component: () => import('./ClientNetworkTablePage.vue'),
    meta: {
      permissions: [Permission.ClientsNetworkView],
    },
  },
  {
    path: 'network/community/:communityId?/visualisation',
    name: 'community-network',
    component: () => import('./CommunityNetwork.vue'),
    meta: {
      permissions: [Permission.ClientsNetworkView],
    },
    props: true,
  },
] satisfies RouteRecordRaw[];
